#import "../fragments/account-attachments-fragment.graphql"

mutation AddAttachmentToAccount($input: AccountFileAddInput!) {
    accountFilesAdd(input: $input) {
        account {
            ...AccountAttachmentsFragment
        }
    }
}
